import { useDispatch } from 'react-redux'
import { ACTIONS } from '../../../../_config'

export function useAppUserAction() {

  const dispatch = useDispatch()

  const logout = () => {
    dispatch({
      type: ACTIONS.USER.LOGOUT,
    })
  }

  const socketInstanceContainer = (socketInstance: Record<string, unknown>) => {
    dispatch({
      type: ACTIONS.USER.SOCKET_INSTANCE_CONTAINER,
      payload: socketInstance
    })
  }

  const guestUserId = (guestUserId: string | number) => {
    dispatch({
      type: ACTIONS.USER.GUEST_USER_ID,
      payload: guestUserId
    })
  }

  const resetGuestUserId = () => {
    dispatch({
      type: ACTIONS.USER.RESET_GUEST_USER_ID,
    })
  }

  const updateDisplayName = (displayName: string) => {
    dispatch({
      type: ACTIONS.USER.UPDATE_DISPLAY_NAME,
      payload: displayName
    })
  }

  return {
    logout,
    socketInstanceContainer,
    guestUserId,
    resetGuestUserId,
    updateDisplayName,
  }
}